// extracted by mini-css-extract-plugin
export default {"homeContent":"Home_homeContent__Fm7J0","homeHeading":"Home_homeHeading__G32eJ","homeList":"Home_homeList__K3wc3"};